export default [
  {
    header: 'База <Музыка>',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Дэшборд',
    route: 'music-dashboard',
    icon: 'BarChart2Icon',
    tagVariant: 'light-warning',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Исполнители',
    route: 'artists',
    icon: 'UsersIcon',
    tagVariant: 'light-warning',
    resource: 'artist-list',
    action: 'view',
  },
  {
    title: 'Найти в Last.FM',
    route: 'artists-search',
    icon: 'SearchIcon',
    tagVariant: 'light-warning',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Треки без файлов',
    route: 'tracks-missing',
    icon: 'AlertCircleIcon',
    tagVariant: 'light-warning',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Треки без артиста',
    route: 'tracks-orphans',
    icon: 'UserXIcon',
    tagVariant: 'light-warning',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Треки',
    route: 'tracks',
    icon: 'MusicIcon',
    tagVariant: 'light-warning',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Списки',
    route: 'lists',
    icon: 'ListIcon',
    tagVariant: 'light-warning',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Темы',
    route: 'autotopics',
    icon: 'ColumnsIcon',
    tagVariant: 'light-warning',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Импорт',
    route: 'music-import',
    icon: 'DownloadIcon',
    tagVariant: 'light-warning',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Яндекс.Музыка',
    route: 'yandex-feed',
    icon: 'RadioIcon',
    tagVariant: 'light-warning',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Свежие релизы',
    route: 'fresh-releases',
    icon: 'DiscIcon',
    tagVariant: 'light-warning',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Поиск Каверов',
    route: 'covers-search',
    icon: 'DiscIcon',
    tagVariant: 'light-warning',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Собрать пак из файлов',
    route: 'pack-from-files',
    icon: 'PackageIcon',
    tagVariant: 'light-warning',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Kworb Чарты',
    route: 'kworb-chart',
    icon: 'BarChart2Icon',
    tagVariant: 'light-warning',
    resource: 'db-music',
    action: 'view',
  },
  {
    header: 'Инструменты',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Поиск в Пакетах',
    route: 'packs-search',
    icon: 'SearchIcon',
    tagVariant: 'light-warning',
    resource: 'db-music',
    action: 'view',
  },
  /*{
    title: 'Топ исполнителей',
    route: 'artists-top',
    icon: 'ArrowUpCircleIcon',
    tagVariant: 'light-warning',
    resource: 'db-music',
    action: 'view',
  },*/
  {
    header: 'Проверка Пакетов',
    resource: 'pack-review',
    action: 'view',
  },
  {
    title: 'Анализ Пакета',
    route: 'pack-analyze',
    icon: 'PieChartIcon',
    tagVariant: 'light-warning',
    resource: 'pack-review',
    action: 'view',
  },
  {
    title: 'Проверка Пакета',
    route: 'pack-validate',
    icon: 'CheckSquareIcon',
    tagVariant: 'light-warning',
    resource: 'pack-review',
    action: 'view',
  },
]
